module.exports = __webpack_public_path__ + "3ddd1280f6e320712021a1f68ee5ae11.svg";